import React from 'react'

const CalculatorStepIndicator = React.forwardRef((props, ref) => (
    <div ref={ref} className="step-indicator"></div>
))

export default CalculatorStepIndicator